import createCachedSelector, { LruObjectCache } from 're-reselect';
import { getObjValue } from 'utils/functions';

const getCurrentUser = props => getObjValue(props, 'getCurrentUser.getCurrentUser', {});

const getUser = props => getObjValue(props, 'user', {});
const getUserEmail = props => getObjValue(props, 'user.email', '');
const getUserFirstName = props => getObjValue(props, 'user.firstName', '');
const getUserLastName = props => getObjValue(props, 'user.lastName', '');
const getUsersEmailsAsString = props => {
  const users = getObjValue(props, 'users', []);
  return JSON.stringify(users);
};

const hasCurrentUser = createCachedSelector(getCurrentUser, getUsersEmailsAsString, (currentUser, users) => {
  const parsedUsers = JSON.parse(users);
  return parsedUsers.find(user => user.email === currentUser.email) !== undefined;
})(props => `hasCurrentUser:${getCurrentUser(props).email}:${JSON.stringify(props.users)}`, {
  cacheObject: new LruObjectCache({ cacheSize: 100 })
});

const isCurrentUser = createCachedSelector([getCurrentUser, getUserEmail], (currentUser, userEmail) =>
  currentUser.email ? currentUser.email === userEmail : false
)(props => `isCurrentUser:${getCurrentUser(props).email}:${props.user.email}`, {
  cacheObject: new LruObjectCache({ cacheSize: 100 })
});

function clearAllCache() {
  hasCurrentUser.clearCache();
  isCurrentUser.clearCache();
}

export { clearAllCache, getUser, isCurrentUser, getCurrentUser, hasCurrentUser, getUserEmail, getUserFirstName, getUserLastName };
